<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-upload-dragger
        :action="url.upload"
        :multiple="false"
        :headers="tokenHeader"
        :file-list="fileList"
        @change="handleChange"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          单击或拖动文件到此区域以上传
        </p>
      </a-upload-dragger>
    </a-spin>
  </a-modal>
</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  name: "BusAssetStorageDetailModal",
  components: {
    JDictSelectTag,
  },
  data () {
    return {
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      form: this.$form.createForm(this),
      title:"操作",
      width:800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      url: {
        upload: process.env.VUE_APP_domianURL+"/file.base/file/upload",
      },
      fileList : [],
    }
  },
  created () {
  },
  methods: {
    upload () {
      this.title = '上传文件'
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleOk () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.close()
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'databaseAddress','databaseName','databaseSpaceSize','databaseType','business','applicationDescription','responsiblePerson','isBackup','backupStrategy','backupMechanism','backupPath','storageMedium','backupTimePoint','backupFrequency','backupTime','retentionDays','backupFileSize','remark'))
    },
    handleChange(info) {
      if(info.success) {
        this.fileList.push({
          id: info.result.id,
          name: info.file.name,
          status: 'done',
          url: info.result.url
        })
      }
      this.fileList = info.fileList
      console.log('文件====》', info, this.fileList)
    },

  }
}
</script>